module.exports = __webpack_public_path__ + "img/rotweinpuroben.aae4d3cb.jpg";